import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Heart, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { API } from '../config/constants';
import BottomNav from '../components/BottomNav';
import CigarImage from '../components/CigarImage';

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const { token } = useAuth();
  const navigate = useNavigate();

  const fetchFavorites = async () => {
    try {
      const res = await axios.get(`${API}/favorites/my`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFavorites(res.data);
    } catch (error) {
      toast.error('Failed to fetch favorites');
    }
  };

  useEffect(() => {
    if (token) {
      fetchFavorites();
    }
  }, [token]);

  if (!token) {
    return (
      <div className="min-h-screen bg-[#0B0B0C] pb-24 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="mb-6 flex justify-center">
            <div className="w-32 h-32 rounded-full bg-white/5 flex items-center justify-center border-2 border-white/10">
              <Heart size={64} className="text-white/30" />
            </div>
          </div>
          <h2 className="playfair text-2xl text-white mb-6">Sign in to view favorites</h2>
          <Button
            data-testid="favorites-signin-button"
            onClick={() => navigate('/auth')}
            className="bg-gradient-to-br from-amber-600 to-amber-800 text-white px-12 py-6 rounded-full text-lg"
          >
            Sign In
          </Button>
        </div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0B0B0C] pb-24">
      <div className="max-w-md mx-auto p-4">
        <h1 className="playfair text-3xl text-white font-bold mb-6">Favorites</h1>

        <div data-testid="favorites-list" className="space-y-4">
          {favorites.length === 0 ? (
            <p className="text-white/50 text-center py-12">No favorites yet</p>
          ) : (
            favorites.map((cigar) => (
              <div
                key={cigar.id}
                data-testid="cigar-card"
                onClick={() => navigate(`/cigar/${cigar.id}`)}
                className="bg-[#141416] rounded-2xl p-4 border border-white/5 hover:border-amber-500/30 transition-all cursor-pointer"
              >
                <div className="flex gap-4">
                  <div className="w-20 h-20 bg-white/5 rounded-lg flex items-center justify-center overflow-hidden">
                    <CigarImage src={cigar.image_url} alt={cigar.name} className="rounded-lg" />
                  </div>
                  <div>
                    <p className="text-xs text-white/50">{cigar.brand}</p>
                    <h3 className="text-lg font-bold text-white">{cigar.name}</h3>
                    <div className="flex items-center gap-2 mt-1">
                      <Star className="text-amber-500 fill-amber-500" size={16} />
                      <span className="text-amber-500">{cigar.average_rating.toFixed(1)}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default FavoritesPage;
